'use strict';

import type { UserSources } from '../../Entities/User/UserSources';
import { EntityCollection } from '../EntityCollection';

export class UserSourcesCollection extends EntityCollection<UserSources> {}
